import React from 'react';
import Icon from '@/components/Icon';

/**
 * 支付方式
 */
export enum PayChannel {
  /** 现金 paypal */
  Cash = 1,
  /** 现金 信用卡 */
  Stripe = 2,
  /** 金币 */
  Gold = 10,
  /** 积分 */
  Integral = 11,
}

export const PayChannelLabelMap = new Map<PayChannel, string>([
  [PayChannel.Cash, '现金支付'],
  [PayChannel.Cash, '信用卡支付'],
  [PayChannel.Gold, '金币支付'],
  // 积分是钻石
  [PayChannel.Integral, '积分兑换'],
]);

export const PayChannelFormatorMap = new Map<
  PayChannel,
  (price?: number) => React.ReactNode
>([
  [
    PayChannel.Cash,
    (price) => (
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        <span className="pay-channel-icon">$</span>
        <span className="pay-channel-num">{(price ?? 0).toFixed(2)}</span>
      </span>
    ),
  ],
  [
    PayChannel.Stripe,
    (price) => (
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        <span className="pay-channel-icon">$</span>
        <span className="pay-channel-num">{(price ?? 0).toFixed(2)}</span>
      </span>
    ),
  ],
  [
    PayChannel.Gold,
    (price) => (
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        <Icon
          id="#hxicon-gold"
          className="pay-channel-icon"
          style={{ fontSize: '1.4em', marginRight: 4 }}
        />
        <span className="pay-channel-num">{price ?? 0}</span>
      </span>
    ),
  ],
  [
    PayChannel.Integral,
    (price) => (
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        <Icon
          id="#hxicon-diamond"
          className="pay-channel-icon"
          style={{ fontSize: '1.4m', marginRight: 4 }}
        />
        <span className="pay-channel-num">{price ?? 0}</span>
      </span>
    ),
  ],
]);

/**
 * 邮费费用类型
 */
export enum LogisticsType {
  /** 满五包邮 */
  OverFive = 1,
  /** 自定义邮费 */
  Normal,
}
